<template>
  <div class="my-box" v-loading="loading">
    <!-- 功能区域 -->
    <el-row>
      <el-card shadow="always">
        <el-form
          label-width="80px"
          class="topS"
          ref="seekData"
          :model="seekData"
        >
          <el-row :gutter="10">
            <el-col :span="1">
              <el-button @click="openpopup" v-if="showEdit">新增</el-button>
            </el-col>
            <el-col :span="3">
              <el-form-item label="品牌">
                <el-select
                  v-model="seekData.brandId"
                  @change="brandChange"
                  clearable
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in brandSelectData"
                    :key="item.name"
                    :label="item.brandName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="门店">
                <el-select
                  v-model="seekData.hotelId"
                  @change="hotelChange"
                  clearable
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in hotelSelectData"
                    :key="item.name"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="房型">
                <el-select
                  v-model="seekData.roomTypeId"
                  clearable
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in roomTypeSelectData"
                    :key="item.name"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2" class="reset-button">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </el-row>
    <!-- 内容区域 -->
    <el-row>
      <el-card shadow="always">
        <div class="my-header-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            :height="height"
            style="width: 100%"
            @selection-change="tab"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              prop="roomTypeId"
              label="房型ID"
            ></el-table-column>
            <el-table-column prop="applianceType" label="语音类型"></el-table-column>
            <el-table-column prop="sceneName" label="场景名称"></el-table-column>
            <el-table-column prop="sceneId" label="面板ID"></el-table-column>
            <el-table-column prop="loopNo" label="按键位置"></el-table-column>
            <el-table-column label="操作" width="280">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  v-if="showDelete"
                  @click="deleteHandle(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next, sizes, total, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="seekData.pageSize"
            :current-page="seekData.pageNum"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </div>
      </el-card>
    </el-row>

    <addView ref="add" @addViewClose="addViewClose" />
  </div>
</template>
<script>
import {
  getKooFeeSceneList,
  eidtKooFeeScene,
  deleteKooFeeScene,
  getBrandSelect,
  getHotelSelect,
  getHotelRoomType
} from "@/api";
import addView from "./addView";

export default {
  components: {
    addView,
  },
  data() {
    return {
      height: 0,
      selectList: [],
      loading: false,
      // 品牌列表数据
      tableData: [],
      // 查询的数据
      total: null,
      seekData: {
        roomTypeId: null,
        brandId: null,
        hotelId: null,
        pageSize: 10,
        pageNum: 1,
      },
      brandSelectData: [],
      hotelSelectData: [],
      roomTypeSelectData: [],
      query: {},
    };
  },
  beforeMount() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    this.height = h - 240;
  },

  computed: {
    // 权限
    showEdit() {
      return this.$store.state.roleMenu.includes("koofee:scene:edit");
    },
    showDelete() {
      return this.$store.state.roleMenu.includes("koofee:scene:delete");
    },
  },
  created() {
    // 调用初始化表格数据方法
    this.initialize();
    this.getList();
  },
  methods: {
    initialize() {
      getBrandSelect().then((res) => {
        if (res.data.data) {
          this.brandSelectData = res.data.data;
        }
      });
    },
    brandChange(id) {
      getHotelSelect(id).then((res) => {
        this.seekData.hotelId = null;
        this.seekData.roomTypeId = null;
        if (res.data.data) {
          this.hotelSelectData = res.data.data;
        }
      });
    },
    hotelChange(id) {
      // 房间类型下拉框
      getHotelRoomType(id).then((res) => {
        this.seekData.roomTypeId = null;
        if (res.data.data) {
          this.roomTypeSelectData = res.data.data;
        }
      });
    },
    tab(list) {
      this.selectList = list;
    },
    openpopup() {
      this.$refs.add.openSet();
    },

    // 初始化表格数据
    getList() {
      this.loading = true;
      getKooFeeSceneList(this.seekData)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.tableData = res.data.data.rows;
            this.total = res.data.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    deleteHandle(row) {
      let that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          deleteKooFeeScene(row.id).then((res) => {
            that.getList();
          });
        })
        .catch((err) => {});
    },
    addViewClose() {
      this.getList();
    },
    // 查询按钮
    handleSearch() {
      this.seekData.pageNum = 1;
      this.query = Object.assign({}, this.seekData);
      this.getList();
    },
    // 重置按钮
    reset() {
      this.seekData.hotelId = null;
      this.seekData.brandId = null;
      this.seekData.roomTypeId = null;
      this.seekData.pageNum = 1;
      this.handleSearch();
    },
    //分页
    handleCurrentChange(pageNum) {
      this.seekData.pageNum = pageNum;
      this.getList();
    },
    handleSizeChange(psize) {
      this.seekData.pageSize = psize;
      this.seekData.pageNum = 1;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.avatarImg {
  height: 40px;
}
.my-box {
  .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .my-input {
    max-width: 209px;
  }
}
.checkBox {
  display: inline-block;
  width: 28%;
}
</style>
